import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-document-found',
  templateUrl: './document-found.component.html',
  styleUrls: ['./document-found.component.scss']
})
export class DocumentFoundComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

}
